import "babel-polyfill";
import "array-flat-polyfill";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "axios";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Vue from "vue";
import VueLogger from "vuejs-logger";
import Multiselect from "@/components/common/MultiSelect";
import VTooltip from "v-tooltip";
import VueCookies from "vue-cookies";
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import App from "./App.vue";
import notification from "@/notify";
import router from "./router";
import store from "./store";
import TinyEditor from "@tinymce/tinymce-vue";
import util from "@/util";

import AvailableAssigned from "@/components/common/AvailableAssigned";
import VueSimpleContextMenu from "vue-simple-context-menu";

Vue.component("TinyEditor", TinyEditor);
Vue.component("vera-multiselect", Multiselect);

const isProduction = process.env.VUE_APP_PRODUCTION === "true";
console.log("PROD", typeof isProduction);
const logOptions = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};
Vue.use(VueLogger, logOptions);

Vue.config.productionTip = false;
Vue.prototype.$notification = notification;
Vue.prototype.$util = util;

Vue.component("available-assigned", AvailableAssigned);
Vue.component("vue-simple-context-menu", VueSimpleContextMenu);

Vue.use(VModal, { dialog: true });
Vue.use(Notifications);
Vue.use(VTooltip);
Vue.use(VueCookies);

window.$cookies.config("7d");

NProgress.configure({ showSpinner: false });
let pendingRequests = 0;
axios.interceptors.request.use((config) => {
  if (config.silent) return config;
  pendingRequests++;
  NProgress.start();
  return config;
});
axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config.silent) return response;
    if (--pendingRequests <= 0) {
      pendingRequests = 0;
      NProgress.done();
    }
    return response;
  },
  (error) => {
    if (error.config && error.config.silent) return Promise.reject(error);
    if (--pendingRequests <= 0) {
      pendingRequests = 0;
      NProgress.done();
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
